export const HOME_PAGE_LIST = [
	{ text: 'Информация', href: '/home/information' },
	{ text: 'Адреса', href: '/home/addresses' },
	{ text: 'Контрагенты', href: '/home/partners' },
	{ text: 'Юр. лица', href: '/home/legals' },
	{ text: 'Маршруты', href: '/home/ways' },
	{ text: 'Машины', href: '/home/cars' },
	{ text: 'Прицепы', href: '/home/trailers' },
	// { text: 'Реквизиты', href: '/home/details' }, Раздел временно скрыт по задаче LOG-310
];
